"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _react = require("react");

var _StoryblokEditablePropsContext = _interopRequireDefault(require("../components/StoryblokEditablePropsContext"));

/* eslint-disable no-underscore-dangle */
function useEditableProps(content) {
  var _useContext = (0, _react.useContext)(_StoryblokEditablePropsContext["default"]),
      filter = _useContext.filter,
      displayName = _useContext.displayName;

  return (0, _react.useMemo)(function () {
    var isFiltered = !filter(content);
    if (!content._editable || isFiltered) return {};
    var options = JSON.parse(content._editable.replace('<!--#storyblok#', '').replace('-->', ''));
    return {
      'data-blok-c': JSON.stringify((0, _objectSpread2["default"])({}, options, {
        name: typeof displayName === 'function' ? displayName(options.name, content) : options.name
      })),
      'data-blok-uid': "".concat(options.id, "-").concat(options.uid),
      className: 'storyblok__outline'
    };
  }, [content, filter, displayName]);
}

var _default = useEditableProps;
exports["default"] = _default;